/* eslint-disable react-hooks/exhaustive-deps */
import { Box, Button, Divider, FormHelperText, InputLabel, MenuItem, OutlinedInput, Paper, Select, Typography, useMediaQuery } from "@mui/material";
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { getFormAttributes, logEvent, saveFormAttributes } from "../../../../../store/api";
import { useDispatch } from "react-redux";
import { showMessageBar } from '../../../../../store/actions'
import { ACTIVITY_DETAIL, EVENTS, MESSAGE_BAR_TYPES } from "../../../../../utils/constants";
import AppScreenLoader from '../../../../../components/AppScreenLoader';
import { styles } from "../../../theme";
import { Form, Formik } from "formik";
import Loader from '../../../../../assets/logo/loader.svg';
import * as yup from 'yup';
import PhoneInputField from '../../../../../components/AppPhoneInput';
import 'react-phone-number-input/style.css';
import paymentData from '../../../../../data/payment-methods.json';
import { AppDatePicker } from "../../../../../components/AppDatePicker";
import moment from "moment";
import { useLocation } from "react-router";


export default function PaymentForm({ setActive,
    active, country, destinationId, paymentCurrency, paymentMethod }) {
    const isSmallDevice = useMediaQuery((theme) => theme.breakpoints.down("sm"));
    const { t } = useTranslation();
    const dispatch = useDispatch();
    const [formAttributes, setFormAttributes] = useState(null);
    const [initialValues, setInitialValue] = useState(null);
    const [phoneCol, setPhoneCol] = useState("");
    const [cardExpirationCol, setCardExpirationCol] = useState("");
    const [cardExpirationYearCol, setCardExpirationYearCol] = useState("");
    const [cardExpirationMonthCol, setCardExpirationMonthCol] = useState("");
    const [attrToken, setAttrToken] = useState("");
    const [validationSchema, setValidationSchema] = useState({});
    const location = useLocation();
    const currentYear = new Date().getFullYear();
    const next20Years = Array.from({ length: 21 }, (_, index) => String(currentYear + index));
    const currentMonth = new Date().getMonth() + 1; // 1-based month indexing
    const months = Array.from({ length: 12 }, (_, index) => String(index + 1).padStart(2, '0')); // 1-based month indexing

    useEffect(() => {
        fetchFormAttributes();
    }, [])

    const getInitialValue = (data) => {
        const value = {};
        const validations = {};

        data.forEach(val => {
            value[val.token] = val?.value || "";
            validations[val.token] = yup.string().matches(val.validation);
            if (val.type === 'PhoneNumber') {
                value[val.token] = val?.value?.length > 4 ? val?.value : "";
                setPhoneCol(val.token);
            }

            if (val.type === 'CardExpiration') {
                setCardExpirationCol(val.token);
                setCardExpirationYearCol(val.token+'_Year');
                setCardExpirationMonthCol(val.token+'_Month');
                value[val.token+'_Year'] = val.value? val.value.split('-')[0]: currentYear;
                value[val.token+'_Month'] = val.value? val.value.split('-')[1]: currentMonth;
            }
        });
        setValidationSchema(validations)
        return value;
    }
    const fetchFormAttributes = async () => {
        try {
            const formData = await getFormAttributes({
                currency: paymentCurrency,
                destinationRecordId: destinationId
            });

            setFormAttributes(formData.result.attributes);
            setAttrToken(formData.result?.attrSetToken)
            setInitialValue(getInitialValue(formData.result.attributes));
        } catch (err) {
            dispatch(showMessageBar(MESSAGE_BAR_TYPES.ERROR, err))
        }
    }
    const handleFormSubmit = async (formvalues) => {
        const currency = paymentCurrency;
        const attributes = [];
        for (const key in formvalues) {
            const data = {
                token: key.replace("attr_", ""),
                value: formvalues[key]
            }
            attributes.push(data)
        }
        const payload = {
            currency,
            attributes: {
                values: attributes,
                attr_set_token: attrToken
            },
            destinationRecordId: destinationId
        }
        try {

            await saveFormAttributes(payload);
            logEvent({
                current: EVENTS.WITHDRAWAL.FIAT_FORM,
                activity: ACTIVITY_DETAIL.WITHDRAWAL.FIAT_FORM,
                meta: {
                    data: {
                        result: 'success',
                        pathname: location.pathname,
                        source: ACTIVITY_DETAIL.WITHDRAWAL.FIAT_FORM
                    }
                }
            });
            handleNext();
        } catch (err) {
            logEvent({
                current: EVENTS.WITHDRAWAL.FIAT_FORM,
                activity: ACTIVITY_DETAIL.WITHDRAWAL.FIAT_FORM,
                meta: {
                    data: {
                        result: 'error',
                        pathname: location.pathname,
                        source: ACTIVITY_DETAIL.WITHDRAWAL.FIAT_FORM
                    }
                }
            });
            dispatch(showMessageBar(MESSAGE_BAR_TYPES.ERROR, err?.response?.data?.message || err.message));
        }
        // handleNext();

    }
    const handleNext = async () => {
        // validate form
        setActive(active + 1);
    }

    const handleBlur = (ev, inputs) => {
        if (paymentData.paymentForm.sensitiveData.includes(inputs.label)) {
            // setIsFocused(false);
            ev.currentTarget.type = "password";
        }
    };

    const handleFocus = (ev, inputs) => {
        if (paymentData.paymentForm.sensitiveData.includes(inputs.label)) {
            // setIsFocused(true);
            ev.currentTarget.type = inputs.type
        }
    };
    if (!formAttributes || !initialValues) {
        return <AppScreenLoader />
    }
    return (<Paper
        sx={{
            backgroundColor: "transparent",
            boxShadow: "none",
            maxHeight: '75vh'
        }}
    > <Box marginTop={2}>
            <Box display={'flex'} justifyContent={'space-between'}>
                <Typography fontSize={14} fontFamily={'Manrope'}>{t('transferMethod')}:</Typography>
                <Typography fontSize={14} fontFamily={'Manrope'} > {paymentMethod.displayName}</Typography>
            </Box>
            <Box display={'flex'} justifyContent={'space-between'}>
                <Typography fontSize={14} fontFamily={'Manrope'}>{t('Currency')}:</Typography>
                <Typography fontSize={14} fontFamily={'Manrope'} > {paymentCurrency.toUpperCase()}</Typography>
            </Box>
        </Box>
        <Divider sx={{ marginTop: 2, marginBottom: 4 }} />
        <Box>
            <Typography fontSize={16} fontFamily={'Manrope'} marginTop={1}>{t("provide_details")} {paymentMethod.displayName.toLowerCase()}</Typography>
        </Box>
        <Formik
            enableReinitialize={true}
            initialValues={{ ...initialValues }}
            validate={async (values) => {
                const errors = {};
                for (const key in values) {
                    if (key === phoneCol) {
                        if (values[key].length > 3 && values[key].length < 13) {
                            errors[key] = t(`InvalidNumber`);
                        }
                        const num = values[key].substring(3, values[key].length - 1);
                        if (values[key].length > 0 && Number(num) <= 0) {
                            errors[key] = t(`InvalidNumber`);
                        }

                    }
                    if (key === cardExpirationCol) {
                        if (!values[cardExpirationYearCol] || !values[cardExpirationMonthCol]) {
                            errors[key] = t(`InvalidExpirationDate`);
                        } else if (Number(values[cardExpirationYearCol]) === currentYear && Number(values[cardExpirationMonthCol]) < currentMonth) {
                            errors[key] = t("ExpirationDateNotCorrect");
                        } else {
                            values[key] = values[cardExpirationYearCol] + '-' + values[cardExpirationMonthCol];
                        }
                    }
                    if (key === cardExpirationYearCol || key === cardExpirationMonthCol) {
                        continue;
                    }
                    if (values[key] !== '') {
                        const flag = validationSchema[key]?.isValidSync(values[key]);
                        if (!flag) {
                            errors[key] =t("InvalidData!")
                        }
                    }
                }
                return errors;
            }}
            onSubmit={handleFormSubmit}
        >
            {({
                errors,
                handleChange,
                isSubmitting,
                isValid,
            }) => (
                <Form autoComplete="off">
                    {
                        formAttributes?.map((inputs, index) => (<Box key={index} marginTop={2}>
                            <InputLabel>{inputs.label} {(!inputs.is_optional) ? <sup style={{ color: "#FF9494" }}>*</sup> : ""}</InputLabel>
                            {(inputs.type === 'PhoneNumber') && (
                                <PhoneInputField
                                    key={index}
                                    numberInputProps={{
                                        style: { ...styles.outlineInput, ...styles.phone },
                                        type: inputs.input_type,
                                        required: !inputs.is_optional,
                                    }}
                                    onChange={(e) => handleChange(e.length > 5 ? e : "", inputs?.token)}
                                    name={inputs?.token}
                                    id={inputs?.token}
                                    value={inputs.value}
                                    defaultCountry={country.code}
                                    disabled={inputs.disabled}
                                />
                            )}
                            {(inputs.type !== 'PhoneNumber' && inputs.input_type !== 'date' && inputs.type !== 'CardExpiration' && inputs.input_type !== 'options') &&
                                (<OutlinedInput
                                    error={!!errors[inputs.token]}
                                    style={styles.outlineInput}
                                    type={paymentData.paymentForm.sensitiveData.includes(inputs.label) ? "password" : inputs.input_type}
                                    required={!inputs.is_optional}
                                    name={inputs.token}
                                    onBlur={(e) => handleBlur(e, inputs)}
                                    onFocus={(e) => handleFocus(e, inputs)}
                                    id={inputs.token}
                                    onChange={handleChange}
                                    defaultValue={inputs?.value}
                                    disabled={inputs.disabled}
                                    autoComplete={inputs.token} />)}
                            {(inputs.type === 'CardExpiration') && (
                                <>
                                    <Select sx={{ width: isSmallDevice ? '30%': '20%' }} onChange={handleChange} name={cardExpirationMonthCol}
                                        disabled={inputs.disabled}
                                        defaultValue={inputs.value? inputs.value.split('-')[1]: currentMonth}
                                        id={cardExpirationMonthCol}
                                        MenuProps={{
                                            PaperProps: {
                                              style: {
                                                maxHeight: '30vh',
                                              },
                                            },
                                        }}>
                                        {
                                            months.map((month) => (
                                                <MenuItem key={month} value={month}>
                                                    {month}
                                                </MenuItem>
                                            ))
                                        }
                                    </Select>
                                    <Select className="expiration_year_cls" sx={{ width: isSmallDevice ? '40%': '25%', marginLeft: '1%' }} onChange={handleChange} name={cardExpirationYearCol}
                                        disabled={inputs.disabled}
                                        defaultValue={inputs.value? inputs.value.split('-')[0]: currentYear}
                                        id={cardExpirationYearCol}
                                        MenuProps={{
                                            PaperProps: {
                                              style: {
                                                maxHeight: '30vh',
                                              },
                                            },
                                        }}>
                                        {
                                            next20Years.map((year) => (
                                                <MenuItem key={year} value={year}>
                                                  {year}
                                                </MenuItem>
                                            ))
                                        }                                        
                                    </Select>
                                </>
                            )}
                            {(inputs.input_type === 'date' && inputs.type !== 'CardExpiration') && (
                                <AppDatePicker
                                    required={!inputs.is_optional}
                                    name={inputs.token}
                                    id={inputs.token}
                                    format={'YYYY-MM-DD'}
                                    style={styles.outlineInput}
                                    // maxDate={new Date()}
                                    // showYearDropdown
                                    // showMonthDropdown
                                    value={inputs.value}
                                    inputProps={{
                                        max: new Date().toISOString().split('T')[0], // Format as YYYY-MM-DD
                                    }}
                                    disabled={inputs.disabled}
                                    onChange={e => {
                                        handleChange(moment(e?.target?.value).format('yyyy-mm-dd'), inputs?.token)
                                        return true;
                                    }} />
                            )}
                            {(inputs.input_type === 'options') && (
                                <Select sx={{ width: '100%' }} onChange={handleChange} name={inputs.token}
                                    disabled={inputs.disabled}
                                    defaultValue={inputs.value}
                                    id={inputs.token}>
                                    {
                                        inputs.validation.split('|').map(val => (
                                            <MenuItem value={val}>{val}</MenuItem>
                                        ))
                                    }

                                </Select>
                            )}

                            <FormHelperText id="component-error-text" sx={{ color: '#FF9494', fontSize: 14 }} >{errors[inputs.token]}</FormHelperText>
                        </Box>

                        ))
                    }
                    <Box sx={{ marginTop: 5 }}>
                        <Typography fontSize={12} fontFamily={'Manrope'} color={'#FF9494'} textAlign={"right"}>* {t('requiredField')}</Typography>
                    </Box>
                    <Button
                        variant="contained"
                        size="large"
                        color="primary"
                        sx={{
                            color: "#041939",
                            marginTop: 4,
                            fontSize: 16,
                            width: "100%",
                            textTransform: "capitalize",
                            borderRadius: "8px",
                            ":disabled": { backgroundColor: "#0088F5", opacity: 0.4 },
                        }}
                        disabled={!isValid}
                        type="submit"
                    >
                        {t("nextStep")}
                        {(isSubmitting) && (
                            <Loader style={styles.loader} className="spin-loader" />
                        )}
                    </Button>
                </Form>
            )}
        </Formik>

    </Paper>)
}